/*
 * NCII — cart drawer autoship toggle (Happy V style)
 * --------------------------------------------------
 * Each paid line in the cart drawer gets a switch (snippets/ncii-cart-autoship.liquid):
 *   one-time  -> autoship : switches straight away (+ a little confetti)
 *   autoship  -> one-time : first shows "Switching to one-time?" with what the customer
 *                           loses; only "Switch to one-time" actually changes the line.
 * The change is a /cart/change.js call that sets (or clears) the line's selling plan,
 * using only plans already on the variant (Loop). Gifts that depend on autoship are
 * removed by assets/ncii-gift-guard.js, which runs after every cart change.
 * Loaded from blocks/cart-drawer_body.liquid.
 */
(function () {
  'use strict';
  if (window.__nciiAutoship) return;
  window.__nciiAutoship = true;

  var FREE_SHIP_CENTS = 7500; // one-time free shipping threshold (matches the drawer bar)
  var SHIP_UNLOCK = ['breath-easy-inhaler-free-shippiing'];
  var busy = false;

  // Free gifts that come with an autoship tier (same rules as ncii-gift-guard.js). When a
  // one-time line is switched to autoship, any missing gift is added back as a _gift line.
  var PILL = 55914857660584, TUMBLER = 55015321862312, INHALER = 55914860019880, BOTTLE_PINK = 55285720449192;
  var AUTOSHIP_GIFTS = {
    67615412879528: { tag: 'primal', gifts: [PILL] },            // Primal 2 + 1 FREE
    67615105745064: { tag: 'primal', gifts: [PILL, TUMBLER] },   // Primal 6 Month
    55914849796264: { tag: 'Berberine 2-bottle subscription gift', gifts: [PILL] },
    52947259031720: { tag: 'Berberine 3-bottle subscription gift', gifts: [PILL, TUMBLER, INHALER] },
    67774542282920: { tag: 'ageless', gifts: [PILL], quiet: true },          // Ageless 2 Month
    67774542315688: { tag: 'ageless', gifts: [PILL, BOTTLE_PINK], quiet: true }, // Ageless 3 Month
    67774569349288: { tag: 'debloat', gifts: [PILL], quiet: true },          // De-Bloat 2 Month
    46972338077864: { tag: 'debloat', gifts: [PILL, TUMBLER], quiet: true }  // De-Bloat 3 Month
  };

  function money(c) {
    var v = (c / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function drawer() { return document.querySelector('cart-drawer'); }

  function sectionIds() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      try { return d.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function paint(parsed) {
    var d = drawer();
    if (!d || !parsed || !parsed.sections) return;
    var done = false;
    if (typeof d.getSectionsToRender === 'function') {
      try {
        d.getSectionsToRender().forEach(function (s) {
          var html = parsed.sections[s.id];
          if (!html) return;
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (!el) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector(s.selector || '.shopify-section');
          if (src) { el.innerHTML = src.innerHTML; done = true; }
        });
      } catch (e) {}
    }
    if (!done && parsed.sections['cart-drawer']) {
      var doc2 = new DOMParser().parseFromString(parsed.sections['cart-drawer'], 'text/html');
      var inner = doc2.querySelector('.drawer__inner');
      var cur = d.querySelector('.drawer__inner');
      if (inner && cur) cur.innerHTML = inner.innerHTML;
    }
    // Keep the drawer's empty state in sync (the empty bag view only shows with is-empty)
    if (typeof parsed.item_count === 'number') d.classList.toggle('is-empty', parsed.item_count === 0);
    d.classList.toggle('is-empty', parsed.item_count === 0);
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function setPlan(row, planId) {
    if (busy) return Promise.resolve();
    busy = true;
    var li = row.closest('li');
    var ov = li && li.querySelector('.loading-overlay');
    if (ov) ov.classList.remove('hidden');
    row.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: parseInt(row.dataset.line, 10),
        quantity: parseInt(row.dataset.qty, 10),
        selling_plan: planId ? parseInt(planId, 10) : null,
        sections: sectionIds(),
        sections_url: location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        if (parsed && parsed.status && parsed.status >= 400) throw new Error(parsed.description || 'error');
        if (planId) return addGifts(row, parsed);
        return parsed;
      })
      .then(function (parsed) {
        paint(parsed);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      })
      .catch(function () {
        if (ov) ov.classList.add('hidden');
        row.classList.remove('is-busy');
      })
      .then(function () { busy = false; });
  }

  function addGifts(row, parsed) {
    var rule = AUTOSHIP_GIFTS[row.dataset.variant];
    if (!rule || !parsed || !parsed.items) return parsed;
    var have = {};
    parsed.items.forEach(function (it) { if (it.properties && it.properties._gift) have[it.variant_id] = true; });
    var add = rule.gifts.filter(function (v) { return !have[v]; })
      .map(function (v) { return { id: v, quantity: 1, properties: { _gift: rule.tag } }; });
    if (!add.length) return parsed;
    // Ageless $0 gifts go through the quiet add (no AddToCart event), see ncii-gift-guard.js
    var req = (rule.quiet && window.nciiQuietCartAdd) ? window.nciiQuietCartAdd(add) : fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: add })
    });
    return req
      .then(function () {
        // re-render with the gifts in place
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: {}, sections: sectionIds(), sections_url: location.pathname })
        }).then(function (r) { return r.json(); });
      })
      .catch(function () { return parsed; });
  }

  // ---------- confetti (one-time -> autoship) ----------
  function confetti(anchor) {
    var r = anchor.getBoundingClientRect();
    var colors = ['#e3147c', '#861b77', '#f7b6d6', '#ffd166', '#7bd3c6', '#b98be0'];
    var wrap = document.createElement('div');
    wrap.className = 'ncii-as-confetti';
    wrap.style.left = (r.left + r.width / 2) + 'px';
    wrap.style.top = (r.top + r.height / 2) + 'px';
    for (var i = 0; i < 28; i++) {
      var p = document.createElement('i');
      var a = Math.random() * Math.PI * 2;
      var dist = 30 + Math.random() * 55;
      p.style.setProperty('--x', Math.cos(a) * dist + 'px');
      p.style.setProperty('--y', Math.sin(a) * dist + 'px');
      p.style.background = colors[i % colors.length];
      p.style.animationDelay = (Math.random() * 80) + 'ms';
      wrap.appendChild(p);
    }
    document.body.appendChild(wrap);
    setTimeout(function () { wrap.remove(); }, 1100);
  }

  // ---------- "Switching to one-time?" dialog ----------
  var dlg;
  function buildDialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'ncii-as-dlg';
    dlg.setAttribute('aria-labelledby', 'ncii-as-dlg-h');
    dlg.innerHTML =
      '<div class="ncii-as-dlg__top"><h2 id="ncii-as-dlg-h">Switching to one-time?</h2>' +
      '<button type="button" class="ncii-as-dlg__x" data-x aria-label="Close">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></div>' +
      '<p class="ncii-as-dlg__intro">Here’s what changes on this order:</p>' +
      '<ul class="ncii-as-dlg__list"></ul>' +
      '<button type="button" class="ncii-as-dlg__keep" data-keep></button>' +
      '<button type="button" class="ncii-as-dlg__switch" data-switch></button>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-x]') || e.target.closest('[data-keep]')) { dlg.close(); return; }
      if (e.target.closest('[data-switch]')) {
        var row = dlg._row; dlg.close();
        if (row) setPlan(row, null);
      }
    });
    return dlg;
  }

  function askOneTime(row) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (cart) {
        var d = buildDialog();
        d._row = row;
        var save = parseInt(row.dataset.lineSave, 10) || 0;
        var items = [];
        items.push('Price goes up ' + money(save) + ' (to ' + money(parseInt(row.dataset.oneTimeLine, 10)) + ')');
        if (cart && cart.items) {
          var key = row.dataset.key;
          var otherSub = false, sameProductSub = false, unlock = false, gifts = 0;
          cart.items.forEach(function (it) {
            if (it.key === key) return;
            var sub = !!(it.selling_plan_allocation && it.selling_plan_allocation.selling_plan);
            if (sub) otherSub = true;
            if (sub && String(it.product_id) === row.dataset.product) sameProductSub = true;
            if (SHIP_UNLOCK.indexOf(it.handle) > -1) unlock = true;
            if (it.properties && it.properties._gift && it.final_line_price === 0) gifts++;
          });
          var newTotal = cart.total_price + save;
          if (!otherSub && !unlock && newTotal < FREE_SHIP_CENTS) items.push('You lose FREE shipping on this order');
          if (gifts && !sameProductSub) items.push('Your FREE gift' + (gifts > 1 ? 's come' : ' comes') + ' out of your cart');
        }
        items.push('You lose free shipping on refills and the mystery gift on your 3rd delivery');
        d.querySelector('.ncii-as-dlg__list').innerHTML = items.map(function (t) { return '<li>' + t + '</li>'; }).join('');
        var pct = parseInt(row.dataset.pct, 10) || 0;
        d.querySelector('[data-keep]').textContent = pct > 0 ? 'Keep my ' + pct + '% OFF' : 'Keep autoship';
        d.querySelector('[data-switch]').textContent = 'Switch to one-time for ' + money(parseInt(row.dataset.oneTimeLine, 10));
        if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
        d.querySelector('[data-keep]').focus();
      });
  }

  // ---------- "Complete your routine" upsells ----------
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-ncii-up-auto]');
    if (!cb) return;
    var card = cb.closest('[data-ncii-up]');
    var ot = card.querySelector('[data-ot]'), sub = card.querySelector('[data-sub]');
    if (ot) ot.hidden = cb.checked;
    if (sub) sub.hidden = !cb.checked;
  });

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-ncii-up-add]');
    if (!add) return;
    e.preventDefault();
    var card = add.closest('[data-ncii-up]');
    if (!card || card.classList.contains('is-busy')) return;
    card.classList.add('is-busy');
    var cb = card.querySelector('[data-ncii-up-auto]');
    var line = { id: parseInt(card.dataset.variant, 10), quantity: 1 };
    if (cb && cb.checked && card.dataset.plan) line.selling_plan = parseInt(card.dataset.plan, 10);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [line], sections: sectionIds(), sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        if (parsed && parsed.status && parsed.status >= 400) throw new Error('add failed');
        if (line.selling_plan) confetti(add);
        parsed.item_count = 1;
        paint(parsed);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      })
      .catch(function () { card.classList.remove('is-busy'); });
  });

  // ---------- shipping protection (own product, on by default) ----------
  var spBusy = false;
  function spSet(on) {
    var row = document.querySelector('cart-drawer [data-ncii-sp]');
    if (!row || spBusy) return Promise.resolve();
    spBusy = true; row.classList.add('is-busy');
    var vid = parseInt(row.dataset.variant, 10);
    // Set (not add) quantity 1: an add.js here incremented, so two overlapping triggers left 2 x $2.99
    // in the cart (Oct 29 QA: subtotal $142.96 vs $139.97 of lines).
    var req = on
      ? post('/cart/update.js', { updates: (function () { var u = {}; u[vid] = 1; return u; })(), attributes: { _ncii_sp_off: '' } })
      : post('/cart/update.js', { updates: (function () { var u = {}; u[vid] = 0; return u; })(), attributes: { _ncii_sp_off: '1' } });
    return req.then(function (parsed) { if (parsed) paint(parsed); })
      .catch(function () {})
      .then(function () { spBusy = false; });
  }
  function post(url, body) {
    body.sections = sectionIds(); body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  // Auto-add once per cart: paid items present, protection not in cart, customer hasn't turned it off.
  function spAuto() {
    var row = document.querySelector('cart-drawer [data-ncii-sp]');
    if (!row || spBusy) return;
    // Wholesale customers never get protection: never auto-add, and take it out if it was added before they logged in
    if (row.dataset.wholesale === 'true') {
      if (row.dataset.on !== 'true') return;
      if ((window.__nciiSpWsTries = (window.__nciiSpWsTries || 0) + 1) > 3) return;
      spBusy = true;
      var w = {}; w[parseInt(row.dataset.variant, 10)] = 0;
      post('/cart/update.js', { updates: w })
        .then(function (parsed) { if (parsed) paint(parsed); })
        .catch(function () {})
        .then(function () { spBusy = false; });
      return;
    }
    // Last product removed: take protection out too, so the bag is truly empty (no opt-out recorded)
    if (row.dataset.on === 'true' && !document.querySelector('cart-drawer li.ncii-ci:not([data-free])')) {
      spBusy = true;
      var u = {}; u[parseInt(row.dataset.variant, 10)] = 0;
      post('/cart/update.js', { updates: u })
        .then(function (parsed) { if (parsed) paint(parsed); })
        .catch(function () {})
        .then(function () { spBusy = false; });
      return;
    }
    if (row.dataset.on === 'true' || row.dataset.off === '1') return;
    if (!document.querySelector('cart-drawer li.ncii-ci:not([data-free])')) return;
    if ((window.__nciiSpTries = (window.__nciiSpTries || 0) + 1) > 3) return;
    spSet(true);
  }
  document.addEventListener('click', function (e) {
    // (i) and the panel's X: show / hide the package protection details
    var info = e.target.closest('[data-ncii-sp-info]');
    if (info) {
      e.preventDefault();
      var row = info.closest('[data-ncii-sp]');
      var panel = row && row.querySelector('.ncii-sp__panel');
      if (!panel) return;
      var open = panel.hidden;
      panel.hidden = !open;
      var opener = row.querySelector('.ncii-sp__info');
      if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open && opener) opener.focus();
      return;
    }
    // "Add package protection" (shown after a customer removed it)
    if (e.target.closest('[data-ncii-sp-add]')) { e.preventDefault(); spSet(true); return; }
    // "Checkout without package protection": remove it, then go straight to checkout
    var skip = e.target.closest('[data-ncii-sp-skip]');
    if (skip) {
      e.preventDefault();
      if (skip.disabled) return;
      skip.disabled = true; skip.classList.add('is-busy');
      var row2 = document.querySelector('cart-drawer [data-ncii-sp]');
      var vid = row2 ? parseInt(row2.dataset.variant, 10) : 0;
      var u = {}; if (vid) u[vid] = 0;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: u, attributes: { _ncii_sp_off: '1' } }) })
        .catch(function () {})
        .then(function () { window.location.href = '/checkout'; });
    }
  });
  var spTimer;
  function spSchedule() { clearTimeout(spTimer); spTimer = setTimeout(spAuto, 600); }
  var spObs = new MutationObserver(spSchedule);
  function spStart() { var d = drawer(); if (d) spObs.observe(d, { childList: true, subtree: true }); spSchedule(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', spStart); else spStart();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ncii-as-btn]');
    if (!btn) return;
    var row = btn.closest('[data-ncii-as]');
    if (!row || row.classList.contains('is-busy')) return;
    e.preventDefault();
    if (row.dataset.on === 'true') {
      askOneTime(row);
    } else if (row.dataset.plan) {
      var sw = row.querySelector('.ncii-as-switch');
      if (sw) { sw.setAttribute('aria-checked', 'true'); confetti(sw); }
      setPlan(row, row.dataset.plan);
    }
  });
})();
